import { render, staticRenderFns } from "./ReviewOfDecorationScheme.vue?vue&type=template&id=742fd011&scoped=true&"
import script from "./ReviewOfDecorationScheme.vue?vue&type=script&lang=js&"
export * from "./ReviewOfDecorationScheme.vue?vue&type=script&lang=js&"
import style0 from "./ReviewOfDecorationScheme.vue?vue&type=style&index=0&id=742fd011&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742fd011",
  null
  
)

export default component.exports